<template>
  <BaseSidebar @open="$emit('open')" @close="$emit('close')">
    <template v-slot:top-bar="{ showContent, activeContent }">
      <ButtonBarItem
          label="Ficha paciente"
          variant="primary"
          @click="showContent(0)"
          :is-active="activeContent === 0"
      ><IconMedicalFile width="100%" height="100%"/></ButtonBarItem>
      <ButtonBarItem
          label="Detalle pauta"
          :variant=" dietHasError ? 'danger' : 'primary'"
          @click="showContent(1)"
          :is-active="activeContent === 1"
      ><IconDiet width="100%" height="100%"/></ButtonBarItem>
      <ButtonBarItem
          label="Biblioteca alimentos"
          variant="primary"
          @click="showContent(2)"
          :is-active="activeContent === 2"
      ><IconFood width="100%" height="100%"/></ButtonBarItem>
    </template>

    <template v-slot:bottom-bar>
      <ButtonBarItem
        label="Agregar comida"
        variant="secondary"
        @click="addMeal"
      ><IconAdd width="100%" height="100%"/></ButtonBarItem>

      <div class="btnbar-separator"></div>

      <ButtonBarItem
        label="Guardar pauta"
        variant="info"
        @click="saveDiet"
        :disabled="!unsavedChanges || isProcessing"
      >
        <IconSave width="100%" height="100%"/>
        <SpinnerBackdrop v-if="isSaving" size="1.5rem" thickness="0.2rem" variant="info"/>
      </ButtonBarItem>
      <ButtonBarItem
        label="Descargar pauta"
        variant="info"
        @click="getDietFile"
        :disabled="isProcessing"
      >
        <IconExport width="100%" height="100%"/>
        <SpinnerBackdrop v-if="isExporting" size="1.5rem" thickness="0.2rem" variant="info"/>
      </ButtonBarItem>
    </template>

    <template v-slot:contents>
      <NutritionalPatientInfo 
        data-content-ref="0" 
        :patient-data="patientData" 
        :poll-data="pollData"
      />
      <DietInfo 
        data-content-ref="1" 
        ref="dietInfo" 
        :diet-data="dietData" 
        @error-changed="errorChanged"
      />
      <FoodInfo
        data-content-ref="2" 
        :food-list="foodList"
        :food-details="foodDetails"
        :is-searching="isSearching"
        @get-food-details="getFoodDetails"
      />
    </template>
  </BaseSidebar>
</template>

<script>
  import BaseSidebar from './base/BaseSidebar'
  import ButtonBarItem from './base/ButtonBarItem'
  import DietInfo from './content/DietInfo'
  import FoodInfo from './content/FoodInfo'
  import IconAdd from "../icon/IconAdd"
  import IconDiet from '../icon/IconDiet'
  import IconExport from "../icon/IconExport"
  import IconFood from '../icon/IconFood'
  import IconMedicalFile from '../icon/IconMedicalFile'
  import IconSave from '../icon/IconSave'
  import NutritionalPatientInfo from './content/NutritionalPatientInfo'
  import SpinnerBackdrop from '../SpinnerBackdrop'

  export default {
    name: 'DietPlanSidebar',
    components: {
      BaseSidebar,
      ButtonBarItem,
      DietInfo,
      FoodInfo,
      IconAdd,
      IconDiet,
      IconExport,
      IconFood,
      IconMedicalFile,
      IconSave,
      NutritionalPatientInfo,
      SpinnerBackdrop
    },
    props: {
      unsavedChanges: {
        type: Boolean,
        default: false,
      },
      isSaving: {
        type: Boolean,
        default: false,
      },
      isExporting: {
        type: Boolean,
        default: false,
      },
      isSearching: {
        type: Boolean,
        default: false,
      },
      patientData: {
        type: Object,
        default: function(){
          return {};
        },
      },
      pollData: {
        type: Object,
        default: function(){
          return {};
        },
      },
      dietData: {
        type: Object,
        default: function(){
          return {};
        },
      },
      foodList: {
        type: Array,
        default: function(){
          return []
        },
      },
      foodDetails: {
        type: Object,
        default: function(){
          return {};
        },
      }
    },
    data: function () {
      return {
        dietHasError: false
      }
    },
    mounted: function () {
      this.dietHasError = this.$refs.dietInfo.getError()
    },
    computed: {
      isProcessing () { return this.isSaving || this.isExporting; }
    },
    methods: {
      getDietFile () {
        this.$emit("get-diet-file");
      },
      saveDiet () {
        this.$emit("save-diet");
      },
      addMeal () {
        this.$emit("add-meal");
      },
      errorChanged (newValue) {
        this.dietHasError = newValue
      },
      getFoodDetails (id) {
        this.$emit("get-food-details", id)
      },
    },
  }
</script>

<style scoped lang="scss">
  .btnbar-separator {
    background-color: $gray-300;
    height: 1px;
    margin: $spacer auto;
    width: $btnbar-btn-size*0.8;
  }
</style>